import { createFileRoute, useParams } from '@tanstack/react-router';

import { WorkspaceEngagementResourceFormScreen } from '@/features/engagement-resources/components/WorkspaceEngagementResourceFormScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/engagement/resources/$id/edit')({
  beforeLoad: () => {
    requirePermission('engagement:update');
  },
  component: WorkspaceEngagementResourceEditRoute,
  staticData: { crumb: 'Edit' },
});

function WorkspaceEngagementResourceEditRoute() {
  const { id } = useParams({ from: '/_staff/admin/workspace/engagement/resources/$id/edit' });
  return <WorkspaceEngagementResourceFormScreen mode="edit" id={id} surface="workspace" />;
}
